import MResourceCard from './MResourceCard.vue';

export { MResourceCard };
export default MResourceCard;
